import {Component, input} from '@angular/core';

@Component({
  selector: 'loading-overlay',
  templateUrl: './loading-overlay.component.html',
  standalone: false
})
export class LoadingOverlayComponent {
  message = input<string>('');
}
